<div class="content">
  <app-header (chatBoxEvent)="chatBoxEvent($event)"></app-header>
  <div class="body-container" [class.black-background]="isChatBoxOpen()">
    <app-message-dialog></app-message-dialog>
    <router-outlet></router-outlet>
  </div>
</div>
